import React, { useEffect } from "react";
import { useController, useWatch } from "react-hook-form";
import InputFieldFormArray from "../inputFieldFormArray/InputFieldFormArray";

const Website = ({ control, register, errors }) => {
  const category = useWatch({ control, name: "category" });
  const isPublisher = category === "Publisher";
  const { field } = useController({
    control,
    name: "website",
    rules: { required: false },
  });
  const { onChange, value } = field;

  useEffect(() => {
    if (!isPublisher && value !== "") {
      onChange("");
    }
  }, [isPublisher, onChange, value]);

  return (
    <InputFieldFormArray
      label="Website name"
      fieldRef={field}
      name="website"
      type="text"
      disabled={!isPublisher}
    />
  );
};

export default Website;
